export enum DigitalTwinCameraMode {
    Orbit = "Orbit",
    Fly = "Fly",
    Walk = "Walk"
}